import {Editor} from '@tiptap/react';
import React, {FC} from 'react';

import {Trans} from '../../../../../../shared/helpers/src/internationalization/react';
import {ColorPickerBox} from './colorPickerBox';

/*
 * Props.
 */

interface HighlightDropdownProps {
  editor: Editor;
}

/*
 * Component.
 */

export const HighlightDropdown: FC<HighlightDropdownProps> = ({editor}) => (
  <ColorPickerBox
    selectedColor={editor.getAttributes('highlight').color}
    onColorSelect={(color) => {
      if (!color) {
        return editor.chain().focus().unsetHighlight().run();
      }
      return editor.chain().focus().toggleHighlight({color}).run();
    }}
    tooltip={<Trans id="knowledge-base-tool-highlight">Text highlight</Trans>}
  />
);
